import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Slider, Pagination } from 'react-slick';
import { Loader } from '../../';
import { factoidSlickSettings } from '../../../constants/slick';

const propTypes = {
  loading: PropTypes.bool.isRequired,
  currentItem: PropTypes.object.isRequired,
};

const defaultProps = {
  loading: true,
  body: {}
};

class FactsCarousel extends React.Component {

  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.paginationRender = this.paginationRender.bind(this);
  }

  previous() {
    this.refs.factSlider.slickPrev();
  }

  next() {
    this.refs.factSlider.slickNext();
  }

  componentWillReceiveProps(nextProps) {
    const currentFacts = _.get(this.props, 'body.facts', []);
    const nextFacts = _.get(nextProps, 'body.facts', []);
    if(currentFacts.length > 0 && nextFacts.length > 0) {
      if (currentFacts[0].id !== nextFacts[0].id) {
        this.refs.factSlider.slickGoTo(0);
      }
    }
  }

  paginationRender(currentPage, totalPages) {
    return (
      <div className="carousel-controller crsl-nav d-flex justify-content-between align-items-center ">
        <button className="ig-btn video-player-btn left previous" onClick={this.previous}><i className="icon-ButtonArrowLeft"></i></button>
        <div ref="slideNumber" className="video-carousel-paging"><span className="pr-10">{currentPage}</span>/<span className="pl-10">{totalPages}</span> </div>
        <button className="ig-btn video-player-btn right next" onClick={this.next}><i className="icon-ButtonArrowRight"></i></button>
      </div>
    );
  }

  getContent() {

    const { facts } = this.props.currentItem;
    let factCount = facts.length;

    return (
      <div>
        <div id="facts-carousel" className="p-30">
          <Slider {...factoidSlickSettings} ref='factSlider' paginationRender={this.paginationRender}>
            {
              facts.map( (fact, index) => {
                return (
                  <div className="fact-slide" key={fact.id}>
                    <div className="inner-slide u-font-foundation-roman u-textSize-18 u-lineHeight-24 text-justify">
                      {fact.fact}
                    </div>
                  </div>
                );
              })
            }
          </Slider>
        </div>
        <div className="text-center" data-carousel-controls="facts-carousel">
          <div className="panel-carousel-controls-wrapper">
              <Pagination name="facts-pagination" />
          </div>
        </div>
      </div>
    )
  }

  render() {

    const { loading } = this.props;

    return (
      <div className={`widget carousel facts ${loading ? 'loading' : ''}`}>
        {
          !loading && _.size(_.get(this.props, 'currentItem.facts')) > 0 ?
          this.getContent() :
          <Loader fill dark style={{ height: 200 }}/>
        }
      </div>
    );

  }

}

FactsCarousel.propTypes = propTypes;
FactsCarousel.defaultProps = defaultProps;

export default FactsCarousel;
